/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback, Fragment, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslate } from "react-admin";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import AddIcon from "@material-ui/icons/Add";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import CompareArrowsIcon from "@material-ui/icons/CompareArrows";
import SearchIcon from "@material-ui/icons/Search";
import {
  Grid,
  Typography,
  TextField,
  Button,
  Switch,
  FormControlLabel,
  Chip,
  InputAdornment,
  Divider,
} from "@material-ui/core";
import { useForm } from "react-hook-form";
import { TextFieldInForm } from "components/Form";
import ActionMenu from "components/ActionMenu";
import ButtonFooter from "components/ButtonFooter";
import DialogActions from "@material-ui/core/DialogActions";
import {
  getAccountGroupingDetail,
  createAccountGroupingDetail,
  updateAccountGroupingDetail,
  delAccountGroupingDetail,
  getAccountGroupingAvailableList,
  assignAccountToGroup,
  removeAccountFromGroup,
  moveAccountBetweenGroups,
} from "services/setting";
import Model from "models/accountGrouping";
import SnackbarUtils from "utils/SnackbarUtils";

const useStyles = makeStyles((theme) => ({
  content: {
    padding: 4,
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  embeddedPanel: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100%",
    backgroundColor: "#fff",
  },
  embeddedHeader: {
    padding: theme.spacing(3, 3, 2),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  embeddedHeaderRow: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: theme.spacing(2),
  },
  embeddedHeaderLeft: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0.75),
    minWidth: 0,
  },
  embeddedMeta: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    flexWrap: "wrap",
  },
  embeddedTitle: {
    fontWeight: 700,
    color: "#1f2a44",
  },
  metaChip: {
    borderRadius: 10,
    fontWeight: 700,
    backgroundColor: "#f3f5fb",
    color: "#546179",
  },
  headerActions: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    gap: theme.spacing(1.25),
    justifyContent: "flex-end",
  },
  statusRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  embeddedContent: {
    padding: theme.spacing(1),
    overflow: "auto",
    flex: 1,
  },
  fieldGrid: {
    marginBottom: theme.spacing(2),
  },
  childButton: {
    borderRadius: 10,
    textTransform: "none",
    height: 40,
  },
  sectionCard: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 14,
    overflow: "hidden",
    marginTop: theme.spacing(2),
  },
  sectionHeader: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: theme.spacing(2),
    padding: theme.spacing(1.5, 2),
    backgroundColor: "#fff",
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  sectionTitleWrap: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
  },
  sectionTitle: {
    fontWeight: 700,
    color: "#1f2a44",
  },
  sectionHint: {
    color: "#7f8aa3",
    fontSize: "0.8rem",
  },
  sectionBody: {
    padding: theme.spacing(1.5, 2, 2),
  },
  tableHead: {
    display: "grid",
    gridTemplateColumns: "1.1fr 1.7fr 100px",
    gap: theme.spacing(1),
    color: "#8a93a7",
    fontSize: "0.74rem",
    fontWeight: 700,
    textTransform: "uppercase",
    padding: theme.spacing(0, 1, 1),
  },
  tableEmpty: {
    padding: theme.spacing(3, 1),
    color: "#b0b7c7",
    textAlign: "center",
    fontStyle: "italic",
  },
  tableRow: {
    display: "grid",
    gridTemplateColumns: "1.1fr 1.7fr 100px",
    gap: theme.spacing(1),
    alignItems: "center",
    padding: theme.spacing(1.1, 1),
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  tableCode: {
    color: "#4256d0",
    fontWeight: 700,
    fontSize: "0.86rem",
  },
  tableName: {
    color: "#1f2a44",
    fontSize: "0.9rem",
  },
  rowActions: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: theme.spacing(0.5),
  },
  iconAction: {
    width: 30,
    height: 30,
  },
  dialogPaper: {
    borderRadius: 16,
  },
  searchInput: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 12,
      backgroundColor: "#f7f9fc",
    },
  },
  modalList: {
    marginTop: theme.spacing(2),
    maxHeight: 320,
    overflowY: "auto",
  },
  modalRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(1),
    padding: theme.spacing(1.1, 0.5),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  modalCode: {
    color: "#4256d0",
    fontWeight: 700,
    fontSize: "0.86rem",
  },
  modalName: {
    color: "#1f2a44",
    fontSize: "0.9rem",
  },
  modalAddButton: {
    minWidth: 28,
    width: 28,
    height: 28,
    borderRadius: 14,
  },
  moveChoice: {
    padding: theme.spacing(1.25, 1.5),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 12,
    marginBottom: theme.spacing(1),
    cursor: "pointer",
    width: "100%",
    textAlign: "left",
    appearance: "none",
    font: "inherit",
  },
  moveChoiceSelected: {
    borderColor: "#5b50f6",
    backgroundColor: "#edf0ff",
  },
  footerActions: {
    //display: "flex",
    //justifyContent: "flex-end",
    gap: theme.spacing(1),
    paddingTop: theme.spacing(2),
  },
  statusLabel: {
    fontSize: "0.75rem",
    fontWeight: 700,
    color: "#546179",
    marginRight: theme.spacing(0.5),
  },
}));

const DialogTitle = ({ children, onClose, ...other }) => {
  const classes = useStyles();
  return (
    <MuiDialogTitle disableTypography {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
};

const flattenTree = (nodes, level = 0, result = []) => {
  for (const node of nodes || []) {
    result.push({ ...node, _depth: level });
    flattenTree(node.Children || [], level + 1, result);
  }
  return result;
};

const findNodeById = (nodes, id) => {
  for (const node of nodes || []) {
    if (Number(node.Id) === Number(id)) return node;
    const nested = findNodeById(node.Children, id);
    if (nested) return nested;
  }
  return null;
};

const collectDescendantIds = (node, result = []) => {
  for (const child of node?.Children || []) {
    result.push(child.Id);
    collectDescendantIds(child, result);
  }
  return result;
};

const DialogItem = (props) => {
  const translate = useTranslate();
  const classes = useStyles();
  const {
    id,
    mode,
    setMode,
    open,
    onClose,
    parentNode,
    currentNode,
    treeData = [],
    embedded = false,
    onAddChild,
    onRequestMoveGroup,
  } = props;
  const [isBtnLoading, setBtnLoading] = useState(false);
  const [data, setData] = useState(Model);
  const [availableAccounts, setAvailableAccounts] = useState([]);
  const [assignedAccounts, setAssignedAccounts] = useState([]);
  const [assignDialogOpen, setAssignDialogOpen] = useState(false);
  const [assignSearchText, setAssignSearchText] = useState("");
  const [moveAccountDialogOpen, setMoveAccountDialogOpen] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [selectedTargetGroupId, setSelectedTargetGroupId] = useState("");
  const mountedRef = useRef(true);
  const methods = useForm({ defaultValues: data });

  const { handleSubmit, reset, watch, setValue } = methods;
  const isActive = watch("IsActive");
  const watchedGroupCode = watch("GroupCode");
  const watchedGroupName = watch("GroupName");
  const watchedLevel = watch("Level");

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);

  const effectiveLevel =
    mode === "add"
      ? parentNode
        ? (parentNode.Level || 0) + 1
        : 1
      : watchedLevel || data.Level || 1;

  const loadData = useCallback(async () => {
    setBtnLoading(true);
    try {
      if (id && id !== 0) {
        const [availableResponse, response] = await Promise.all([
          getAccountGroupingAvailableList(),
          getAccountGroupingDetail(id),
        ]);
        if (mountedRef.current) {
          const rawAvailable = availableResponse?.Data || [];
          const assigned = response?.Accounts || [];
          const nextAvailable = rawAvailable.filter(
            (account) =>
              !assigned.some((item) => Number(item.Id) === Number(account.Id)),
          );
          setData(response);
          reset(response);
          setAssignedAccounts(assigned);
          setAvailableAccounts(nextAvailable);
        }
      } else {
        const availableResponse = await getAccountGroupingAvailableList();
        if (mountedRef.current) {
          const rawAvailable = availableResponse?.Data || [];
          const nextModel = {
            ...Model,
            ParentGroupId: parentNode?.Id || null,
            Level: parentNode ? (parentNode.Level || 0) + 1 : 1,
          };
          setData(nextModel);
          reset(nextModel);
          setAssignedAccounts([]);
          setAvailableAccounts(rawAvailable);
        }
      }
    } finally {
      if (mountedRef.current) {
        setBtnLoading(false);
      }
    }
  }, [id, parentNode, reset]);

  useEffect(() => {
    if (open) {
      loadData();
    }
  }, [open, loadData]);

  const saveAccountGroup = async (values) => {
    if (mode === "edit") {
      const payload = {
        ...values,
        Id: id,
        ParentGroupId: data.ParentGroupId ?? values.ParentGroupId ?? null,
        Level: data.Level ?? values.Level ?? effectiveLevel,
      };
      const { Code, InternalMessage, UserMessage } =
        await updateAccountGroupingDetail(payload);
      if (Code === 0) {
        SnackbarUtils.success(UserMessage);
        onClose(id);
      } else if (InternalMessage) {
        SnackbarUtils.error(InternalMessage);
      } else {
        SnackbarUtils.warning(UserMessage);
      }
      if (mountedRef.current) {
        setBtnLoading(false);
      }
      return;
    }

    const payload = {
      ...values,
      ParentGroupId: parentNode?.Id || null,
      Level: effectiveLevel,
      UserModified: Model.UserModified,
    };
    const { Code, InternalMessage, UserMessage } =
      await createAccountGroupingDetail(payload);
    if (Code === 0) {
      SnackbarUtils.success(UserMessage);
      onClose(parseInt(InternalMessage, 10));
    } else if (InternalMessage) {
      SnackbarUtils.error(InternalMessage);
    } else {
      SnackbarUtils.warning(UserMessage);
    }
    if (mountedRef.current) {
      setBtnLoading(false);
    }
  };

  const onSubmit = (values) => {
    setBtnLoading(true);
    saveAccountGroup({
      ...data,
      ...values,
      UserModified: Model.UserModified,
    });
  };

  const handleDelete = async () => {
    if (!id) return;
    SnackbarUtils.delConfirm(
      translate("ra.question.confirmDel"),
      async function () {
        const { Code, UserMessage } = await delAccountGroupingDetail(id);
        if (Code === 0) {
          SnackbarUtils.success(UserMessage);
          onClose(id);
        }
      },
    );
  };

  const handleCancel = () => {
    if (id === 0) {
      onClose();
      return;
    }
    loadData();
    setMode("view");
  };

  const handleAssignSingleAccount = async (account) => {
    const { Code, UserMessage } = await assignAccountToGroup({
      GroupId: id,
      AccountIds: [account.Id],
    });
    if (Code === 0) {
      SnackbarUtils.success(UserMessage);
      if (mountedRef.current) {
        setAssignedAccounts((prev) => [...prev, account]);
        setAvailableAccounts((prev) =>
          prev.filter((item) => Number(item.Id) !== Number(account.Id)),
        );
      }
    } else {
      SnackbarUtils.warning(UserMessage);
    }
  };

  const handleRemoveAccount = async (account) => {
    const { Code, UserMessage } = await removeAccountFromGroup({
      GroupId: id,
      AccountIds: [account.Id],
    });
    if (Code === 0) {
      SnackbarUtils.success(UserMessage);
      if (mountedRef.current) {
        setAssignedAccounts((prev) =>
          prev.filter((item) => Number(item.Id) !== Number(account.Id)),
        );
        setAvailableAccounts((prev) => [...prev, account]);
      }
    } else {
      SnackbarUtils.warning(UserMessage);
    }
  };

  const handleOpenMoveAccount = (account) => {
    setSelectedAccount(account);
    setSelectedTargetGroupId("");
    setMoveAccountDialogOpen(true);
  };

  const handleMoveAccount = async () => {
    if (!selectedAccount || selectedTargetGroupId === "") return;
    const { Code, UserMessage, InternalMessage } =
      await moveAccountBetweenGroups({
        FromGroupId: id,
        ToGroupId: selectedTargetGroupId,
        AccountIds: [selectedAccount.Id],
      });
    if (Code === 0) {
      SnackbarUtils.success(UserMessage);
      if (mountedRef.current) {
        setAssignedAccounts((prev) =>
          prev.filter((item) => Number(item.Id) !== Number(selectedAccount.Id)),
        );
        setMoveAccountDialogOpen(false);
        setSelectedAccount(null);
      }
    } else if (InternalMessage) {
      SnackbarUtils.error(InternalMessage);
    } else {
      SnackbarUtils.warning(UserMessage);
    }
  };

  const assignableAccounts = availableAccounts.filter((account) =>
    [account.AccCode, account.Description]
      .filter(Boolean)
      .some((value) =>
        value.toLowerCase().includes(assignSearchText.trim().toLowerCase()),
      ),
  );

  const flattenedGroups = flattenTree(treeData);
  const currentTreeNode = currentNode || findNodeById(treeData, id);
  const descendantIds = collectDescendantIds(currentTreeNode, []);
  const targetMoveGroups = flattenedGroups.filter(
    (group) =>
      Number(group.Id) !== Number(id) &&
      !descendantIds.includes(group.Id) &&
      group.IsActive !== false,
  );

  const headerTitle =
    mode === "add"
      ? translate("ra.field.Create New Group")
      : watchedGroupName || props.title;

  const headerMenuControl = [
    {
      name: "Add Child",
      fnc: () => currentNode && onAddChild && onAddChild(currentNode),
      disabled: mode !== "view" || (currentNode?.Level || data.Level || 1) >= 4,
    },
    {
      name: "Move",
      fnc: () => onRequestMoveGroup && onRequestMoveGroup(),
      disabled: mode !== "view",
    },
    {
      name: "Edit",
      fnc: () => setMode("edit"),
      disabled: mode !== "view",
    },
    {
      name: "Delete",
      fnc: handleDelete,
      disabled: mode !== "view",
    },
  ];

  const formContent = (
    <Fragment>
      {mode === "view" && id !== 0 ? (
        <ActionMenu
          menuControl={headerMenuControl}
          justify="flex-end"
          size="auto"
        />
      ) : null}
      {mode === "view" && id !== 0 ? (
        <Divider style={{ marginBottom: 16 }} />
      ) : null}
      <form>
        <Grid
          container
          spacing={2}
          alignItems="flex-end"
          className={classes.fieldGrid}
        >
          <Grid item xs={12} md={6}>
            <TextFieldInForm
              label={`* ${translate("ra.field.Group Code")}`}
              name="GroupCode"
              variant="outlined"
              margin="dense"
              methods={methods}
              disabled={mode !== "add"}
              rule={{
                required: {
                  value: true,
                  message: translate("ra.validation.required"),
                },
                maxLength: {
                  value: 20,
                  message: "maximum length is 20",
                },
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextFieldInForm
              label={`* ${translate("ra.field.Group Name")}`}
              name="GroupName"
              variant="outlined"
              margin="dense"
              methods={methods}
              disabled={mode === "view"}
              rule={{
                required: {
                  value: true,
                  message: translate("ra.validation.required"),
                },
                maxLength: {
                  value: 255,
                  message: "maximum length is 255",
                },
              }}
            />
          </Grid>
        </Grid>

        {mode === "add" ? (
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                variant="outlined"
                margin="dense"
                label={translate("ra.field.Parent Group")}
                value={
                  parentNode
                    ? `${parentNode.GroupCode} - ${parentNode.GroupName}`
                    : translate("ra.field.Root Level")
                }
                disabled
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                variant="outlined"
                margin="dense"
                label="Level"
                value={effectiveLevel}
                disabled
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControlLabel
                control={
                  <Switch
                    checked={isActive ?? true}
                    onChange={(event) =>
                      setValue("IsActive", event.target.checked)
                    }
                    color="primary"
                    disabled={mode === "view"}
                  />
                }
                label={translate("ra.field.Active")}
              />
            </Grid>
          </Grid>
        ) : (
          <div className={classes.sectionCard}>
            <div className={classes.sectionHeader}>
              <div className={classes.sectionTitleWrap}>
                <div className={classes.sectionTitle}>
                  {translate("ra.field.Assigned Accounts")}
                </div>
                <div className={classes.sectionHint}>
                  {translate("ra.field.Assign Account Hint", {
                    code: watchedGroupCode || data.GroupCode,
                  })}
                </div>
              </div>
              <Button
                variant="contained"
                color="primary"
                startIcon={<AddIcon />}
                className={classes.childButton}
                onClick={() => setAssignDialogOpen(true)}
              >
                Assign
              </Button>
            </div>
            <div className={classes.sectionBody}>
              <div className={classes.tableHead}>
                <div>{translate("ra.field.Code")}</div>
                <div>{translate("ra.field.Account Name")}</div>
                <div style={{ textAlign: "right" }}>
                  {translate("ra.field.Actions")}
                </div>
              </div>

              {!assignedAccounts.length ? (
                <div className={classes.tableEmpty}>
                  {translate("ra.field.No Accounts Assigned")}
                </div>
              ) : (
                assignedAccounts.map((account) => (
                  <div key={account.Id} className={classes.tableRow}>
                    <div className={classes.tableCode}>{account.AccCode}</div>
                    <div className={classes.tableName}>
                      {account.Description}
                    </div>
                    <div className={classes.rowActions}>
                      <IconButton
                        size="small"
                        className={classes.iconAction}
                        onClick={() => handleOpenMoveAccount(account)}
                      >
                        <CompareArrowsIcon
                          fontSize="small"
                          style={{ color: "#4570ff" }}
                        />
                      </IconButton>
                      <IconButton
                        size="small"
                        className={classes.iconAction}
                        onClick={() => handleRemoveAccount(account)}
                      >
                        <DeleteOutlineIcon
                          fontSize="small"
                          style={{ color: "#c0c7d6" }}
                        />
                      </IconButton>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        )}

        {mode !== "view" ? (
          <div className={classes.footerActions}>
            <ButtonFooter
              disabled={isBtnLoading}
              SaveFnc={handleSubmit(onSubmit)}
              CancelFnc={handleCancel}
              saveTitle={translate("ra.field.Save Group")}
            />
          </div>
        ) : null}
      </form>
    </Fragment>
  );

  const embeddedContent = (
    <div className={classes.embeddedPanel}>
      <div className={classes.embeddedHeader}>
        <div className={classes.embeddedHeaderRow}>
          <div className={classes.embeddedHeaderLeft}>
            <div className={classes.embeddedMeta}>
              <Chip
                label={`LV ${effectiveLevel}`}
                size="small"
                className={classes.metaChip}
              />
              {id ? (
                <Chip
                  label={`ID: G${id}`}
                  size="small"
                  className={classes.metaChip}
                />
              ) : null}
            </div>
            <Typography variant="h5" className={classes.embeddedTitle}>
              {headerTitle}
            </Typography>
          </div>

          {id === 0 ? null : (
            <div className={classes.headerActions}>
              <div className={classes.statusRow}>
                <span className={classes.statusLabel}>
                  {translate("ra.field.Active").toUpperCase()}
                </span>
                <Switch
                  checked={isActive ?? true}
                  onChange={(event) =>
                    setValue("IsActive", event.target.checked)
                  }
                  color="primary"
                  disabled={mode !== "edit"}
                />
              </div>
            </div>
          )}
        </div>
      </div>
      <div className={classes.embeddedContent}>{formContent}</div>
    </div>
  );

  if (embedded) {
    return (
      <Fragment>
        {embeddedContent}

        <Dialog
          open={assignDialogOpen}
          onClose={() => setAssignDialogOpen(false)}
          fullWidth
          maxWidth="xs"
          classes={{ paper: classes.dialogPaper }}
        >
          <DialogTitle onClose={() => setAssignDialogOpen(false)}>
            {translate("ra.field.Assign Account Code")}
          </DialogTitle>
          <DialogContent>
            <TextField
              fullWidth
              size="small"
              variant="outlined"
              placeholder={translate("ra.field.Search accounts...")}
              value={assignSearchText}
              onChange={(event) => setAssignSearchText(event.target.value)}
              className={classes.searchInput}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon fontSize="small" color="action" />
                  </InputAdornment>
                ),
              }}
            />

            <div className={classes.modalList}>
              {assignableAccounts.map((account) => (
                <div key={account.Id} className={classes.modalRow}>
                  <div>
                    <div className={classes.modalCode}>{account.AccCode}</div>
                    <div className={classes.modalName}>
                      {account.Description}
                    </div>
                  </div>
                  <IconButton
                    size="small"
                    className={classes.modalAddButton}
                    onClick={async () => {
                      await handleAssignSingleAccount(account);
                    }}
                  >
                    <AddIcon fontSize="small" style={{ color: "#7c8bff" }} />
                  </IconButton>
                </div>
              ))}
              {!assignableAccounts.length ? (
                <div className={classes.tableEmpty}>
                  {translate("ra.info.notransaction")}
                </div>
              ) : null}
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setAssignDialogOpen(false)}>
              {translate("ra.action.cancel")}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={moveAccountDialogOpen}
          onClose={() => setMoveAccountDialogOpen(false)}
          fullWidth
          maxWidth="sm"
          classes={{ paper: classes.dialogPaper }}
        >
          <DialogTitle onClose={() => setMoveAccountDialogOpen(false)}>
            {translate("ra.field.Move")}
          </DialogTitle>
          <DialogContent>
            {selectedAccount ? (
              <div
                className={`${classes.moveChoice} ${classes.moveChoiceSelected}`}
              >
                <div className={classes.modalCode}>
                  {selectedAccount.AccCode}
                </div>
                <div className={classes.modalName}>
                  {selectedAccount.Description}
                </div>
              </div>
            ) : null}

            <Typography variant="subtitle2" gutterBottom>
              {translate("ra.field.Target Parent Group")}
            </Typography>
            <div className={classes.modalList}>
              {targetMoveGroups.map((group) => {
                const selected =
                  Number(selectedTargetGroupId) === Number(group.Id);
                return (
                    <button
                      type="button"
                      key={group.Id}
                      className={`${classes.moveChoice} ${selected ? classes.moveChoiceSelected : ""}`}
                      onClick={() => setSelectedTargetGroupId(group.Id)}
                      aria-pressed={selected}
                      style={{ marginLeft: group._depth * 12 }}
                    >
                      <div className={classes.modalCode}>{group.GroupCode}</div>
                      <div className={classes.modalName}>{group.GroupName}</div>
                    </button>
                );
              })}
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setMoveAccountDialogOpen(false)}>
              {translate("ra.action.cancel")}
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={handleMoveAccount}
            >
              {translate("ra.field.Move")}
            </Button>
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }

  return (
    <Dialog open={open} fullWidth maxWidth="md">
      <DialogTitle onClose={onClose}>{props.title}</DialogTitle>
      <DialogContent dividers className={classes.content}>
        {formContent}
      </DialogContent>
    </Dialog>
  );
};

export default DialogItem;
